import { render, staticRenderFns } from "./AddBankStatement.vue?vue&type=template&id=2d2ce492&"
import script from "./AddBankStatement.vue?vue&type=script&lang=js&"
export * from "./AddBankStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports